module.exports = __webpack_public_path__ + "iq.dc0f61f43cc76c7aca23.svg";


//////////////////
// WEBPACK FOOTER
// E:/proj/news12/zb-n12/scadmin/client/src/assets/fonts/flag-icon-css/flags/4x3/iq.svg
// module id = ../../../../../src/assets/fonts/flag-icon-css/flags/4x3/iq.svg
// module chunks = styles